/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_AccessInputs */

const en_public_access = /** @type {(inputs: Public_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Access`)
};

const id_public_access = /** @type {(inputs: Public_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Publik`)
};

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const es_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const fr_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const de_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const ja_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const zh_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const ar_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const it_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const ru_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const pt_public_access = en_public_access;

/** @type {(inputs: Public_AccessInputs) => LocalizedString} */
const ko_public_access = en_public_access;

/**
* | output |
* | --- |
* | "Public Access" |
*
* @param {Public_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const public_access = /** @type {((inputs?: Public_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_access(inputs)
	if (locale === "es") return es_public_access(inputs)
	if (locale === "fr") return fr_public_access(inputs)
	if (locale === "de") return de_public_access(inputs)
	if (locale === "ja") return ja_public_access(inputs)
	if (locale === "zh") return zh_public_access(inputs)
	if (locale === "ar") return ar_public_access(inputs)
	if (locale === "id") return id_public_access(inputs)
	if (locale === "it") return it_public_access(inputs)
	if (locale === "ru") return ru_public_access(inputs)
	if (locale === "pt") return pt_public_access(inputs)
	return ko_public_access(inputs)
});